import { defineStore, acceptHMRUpdate } from 'pinia'

export const useMenuStore = defineStore({
  id: 'menu',
  state: () => ({
    navs: [],
    menus: []
  }),
  actions: {
    setNavs (navs) {
      this.navs = navs
    },
    setMenus (menus) {
      this.menus = menus
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useMenuStore, import.meta.hot))
}
